import { variablePlaceholderSchema } from './raw-variable-placeholder';

export interface VariableObject {
  $variable: { name: string; default_value?: unknown };
}

export const isVariableObject = (obj: unknown): obj is VariableObject => {
  return variablePlaceholderSchema.safeParse(obj).success;
};

export const hasVariables = (obj: unknown): boolean => {
  if (obj === null || obj === undefined) {
    return false;
  }

  // Check if this object matches the variable pattern: { "$variable": { "name": <string> } }
  if (isVariableObject(obj)) {
    return true;
  }

  // If it's an array, check each element
  if (Array.isArray(obj)) {
    return obj.some((item) => hasVariables(item));
  }

  // If it's an object, check all its properties recursively
  if (typeof obj === 'object') {
    return Object.values(obj).some((value) => hasVariables(value));
  }

  return false;
};
